import { Amplify } from 'aws-amplify';
import { env } from '@/env';

export function configureAmplify() {
  // The env schema (@/env) already rejects empty pool ids at import time.
  const userPoolId = env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = env.VITE_COGNITO_USER_POOL_CLIENT_ID;
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        ...(env.VITE_COGNITO_ENDPOINT ? { userPoolEndpoint: env.VITE_COGNITO_ENDPOINT } : {}),
      },
    },
  });
}
